export const TOGGLE_LOADING = 'loading/toggle-loading';
export const SET_LOADING = 'loading/set-loading';
export const TOGGLE_GROUP_ITEM_LOADING = 'loading/toggle-group-item-loading';
